import { requestData } from '../../config/services/datasets';
import { SERVER } from '../../config/server.config';
import * as TYPES from '../types';

export const setPlayersNoteType= (results) => {
    return {
      type: TYPES.GET_PLAYERS_NOTE_TYPE,
      playersNoteTypes: results,
    };
  };

export const setPlayerNote = (results) => {
    return {
      type: TYPES.GET_PLAYER_NOTE,
      modalPlayerNote: results
    };
  };

export const loadPlayerNote = (gameId, playerId) =>{
    return async (dispatch) => {
    const results = await requestData(SERVER.GET_PLAYER_NOTE(gameId, playerId));
    let defaultPlayerNote;
    if(results === null ||(results && results.length === 0)){
        defaultPlayerNote =[];
        dispatch(setPlayerNote(defaultPlayerNote));
    }else{
      dispatch(setPlayerNote(results[0]));
    }
  };   
};

export const loadPlayersNoteType = (gameId) =>{
    return async (dispatch) => {
    const results = await requestData(SERVER.GET_PLAYERS_NOTES(gameId));
    let defaultNoteTypes;
    if(results === null ||(results && results.length === 0)){
      defaultNoteTypes =[];
      dispatch(setPlayersNoteType(defaultNoteTypes));
    }else{
      dispatch(setPlayersNoteType(results));
    }
  };   
};

export const updatePlayerNote = (playerNote, noteType, gameId, playerId, teamId) =>{
  return async (dispatch) =>{
    const body = [{
        dsid: gameId,
        playerId: playerId,
	      teamId: teamId,
        note: playerNote,
		    type: noteType === 0? '': noteType
    }];
    const jsonBody = JSON.stringify(body);
    fetch(SERVER.SET_PLAYER_NOTE(gameId, playerId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .finally(() => {
        dispatch(loadPlayersNoteType(gameId, playerId));
      });
  };
};